module.exports = __webpack_public_path__ + "static/img/4.daa7e78.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/7/1/sp/4.png
// module id = 2vcv
// module chunks = 0